// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Aniversariantes_MensagemConfigInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import { registerContract } from './validate'

export interface Aniversariantes_MensagemConfigInput {
mensagem: string
}

registerContract('Aniversariantes_MensagemConfigInput', {
  mensagem: { type: 'string',  required: true },
})
